'use client';

import { useMemo } from 'react';

import { useApiV1Ctx } from '@/components/providers/v1-api';

export function useAgentBlocks() {
  const { api } = useApiV1Ctx();
  return api.agentBlocks.listBlocks.useQuery(undefined, {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
}

export function useAgentBlock(id: string | null) {
  const { data } = useAgentBlocks();
  const block = useMemo(() => {
    if (id === null) {
      return null;
    }
    const item = data?.find((item) => item.id === id);
    if (!item) return null;
    return item;
  }, [data, id]);
  return { data: block };
}

export function useAgentConfigs() {
  const { api } = useApiV1Ctx();
  return api.agentConfigs.listAgentConfigs.useQuery(undefined, {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
}

export function useAgentConfig(id: string | null) {
  const { data } = useAgentConfigs();

  const config = useMemo(() => {
    if (id === null) {
      return null;
    }
    const item = data?.find((item) => item.id === id);
    if (!item) return null;
    return item;
  }, [data, id]);

  return { data: config };
}

export function useVoiceAgents() {
  const { api } = useApiV1Ctx();
  return api.agentVoice.listVoiceAgents.useQuery(undefined, {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
}

export function useVoiceAgent(id: string | null) {
  const { data, refetch } = useVoiceAgents();
  const agent = useMemo(() => {
    if (id === null) {
      return null;
    }
    const item = data?.find((item) => item.id === id);
    if (!item) return null;
    return item;
  }, [data, id]);
  return { data: agent, refetch };
}
